require('./src/styles/global.css');
require('swiper/css');
require('swiper/css/free-mode');
require('swiper/css/pagination');
